import { render, staticRenderFns } from "./MarginItem.vue?vue&type=template&id=53b0c24b"
import script from "./MarginItem.vue?vue&type=script&lang=js"
export * from "./MarginItem.vue?vue&type=script&lang=js"
import style0 from "./MarginItem.vue?vue&type=style&index=0&id=53b0c24b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports